// const stories = [
//   {
//     name: 'Skyline Heights',
//     location: 'Baner, Pune',
//     irrWidth: '77%',
//     metrics: [
//       { value: '24%', label: 'IRR', green: true },
//       { value: '186', label: 'Units' },
//       { value: '₹42 Cr', label: 'Value' },
//       { value: '28', label: 'Months' },
//     ],
//   },
//   {
//     name: 'Residences at Koregaon',
//     location: 'Koregaon Park, Pune',
//     irrWidth: '100%',
//     metrics: [
//       { value: '31%', label: 'IRR', green: true },
//       { value: '94', label: 'Units' },
//       { value: '₹68 Cr', label: 'Value' },
//       { value: '22', label: 'Months' },
//     ],
//   },
//   {
//     name: 'Commercial Hub 37',
//     location: 'Hinjewadi, Pune',
//     irrWidth: '61%',
//     metrics: [
//       { value: '19%', label: 'IRR', green: true },
//       { value: '240', label: 'Units' },
//       { value: '₹95 Cr', label: 'Value' },
//       { value: '36', label: 'Months' },
//     ],
//   },
// ];

// function StoriesSection() {
//   return (
//     <section id="stories" data-section className="section-wrap fade-up">
//       <p className="stories-tag">Track Record</p>
//       <h2 className="stories-title">Proven Outcomes</h2>

//       <div className="stories-table">
//         <div className="stories-thead">
//           <div className="th-left">Project</div>
//           <div className="th">IRR</div>
//           <div className="th">Units</div>
//           <div className="th">Value</div>
//           <div className="th">Timeline</div>
//         </div>

//         {stories.map((story, index) => (
//           <div key={story.name} className="story-row">
//             <div className="story-info">
//               <span className="story-num">0{index + 1}</span>
//               <div className="story-copy">
//                 <div className="story-name">{story.name}</div>
//                 <div className="story-loc">{story.location}</div>
//                 <div className="irr-bar">
//                   <div className="irr-fill" style={{ width: story.irrWidth }} />
//                 </div>
//               </div>
//             </div>

//             <div className="stat-col stat-irr">
//               <div className={`stat-val ${story.metrics[0].green ? 'stat-green' : ''}`}>
//                 {story.metrics[0].value}
//               </div>
//               <div className="stat-lbl">{story.metrics[0].label}</div>
//             </div>

//             <div className="stats-strip">
//               {story.metrics.slice(1).map((metric) => (
//                 <div key={metric.label} className="stat-col">
//                   <div className={`stat-val ${metric.green ? 'stat-green' : ''}`}>
//                     {metric.value}
//                   </div>
//                   <div className="stat-lbl">{metric.label}</div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// }

// export default StoriesSection;




/*
const stories = [
  {
    name: 'Skyline Heights',
    location: 'Baner, Pune',
    status: 'COMPLETED',
    metrics: [
      { value: '24%', label: 'IRR Delivered' },
      { value: '186', label: 'Units Delivered' },
      { value: '28', label: 'Months Timeline' },
      { value: '₹42 Cr', label: 'Total Value' },
    ],
    insight:
      'FSI maximization strategy added 22% more sellable area - a direct outcome of architectural intelligence.',
  },
  {
    name: 'Residences at Koregaon',
    location: 'Koregaon Park, Pune',
    status: 'COMPLETED',
    metrics: [
      { value: '31%', label: 'IRR Delivered' },
      { value: '94', label: 'Units Delivered' },
      { value: '22', label: 'Months Timeline' },
      { value: '₹68 Cr', label: 'Total Value' },
    ],
    insight:
      'Luxury low-rise format identified through demand analysis - 100% sold in pre-launch phase.',
  },
  {
    name: 'Commercial Hub 37',
    location: 'Hinjewadi, Pune',
    status: 'COMPLETED',
    metrics: [
      { value: '19%', label: 'IRR Delivered' },
      { value: '240', label: 'Units Delivered' },
      { value: '36', label: 'Months Timeline' },
      { value: '₹95 Cr', label: 'Total Value' },
    ],
    insight:
      'Mixed-use positioning reduced unsold inventory risk by 40% vs comparable single-use projects.',
  },
];

function StoriesSection() {
  return (
    <section id="stories" className="stories-section">
      <p className="stories-tagline">Track Record</p>
      <h2 className="stories-heading">Proven Outcomes</h2>
      <p className="stories-description">
        Real projects. Measurable results. Consistent delivery across markets.
      </p>

      <div className="stories-grid">
        {stories.map((story) => (
          <div key={story.name} className="story-card">
            <span className="story-status">{story.status}</span>

            <h3 className="story-title">{story.name}</h3>
            <p className="story-location">Location: {story.location}</p>

            <div className="story-metrics">
              {story.metrics.map((metric) => (
                <div className="metric-box" key={metric.label}>
                  <div className="metric-value">{metric.value}</div>
                  <div className="metric-label">{metric.label}</div>
                </div>
              ))}
            </div>

            <div className="story-divider"></div>

            <p className="story-insight">“{story.insight}”</p>
          </div>
        ))}
      </div>
    </section>
  );
}
*/

import skylineImage from '../assets/images/opportunities/greens-at-wakad.png';
import koregaonImage from '../assets/images/opportunities/central-district-9.png';
import commercialImage from '../assets/images/opportunities/meridian-tower.png';
import riverfrontImage from '../assets/images/opportunities/central-district-9.png';

const outcomeStories = [
  {
    name: 'Skyline Heights',
    location: 'Baner, Pune',
    status: 'COMPLETED',
    image: skylineImage,
    metrics: [
      { value: '24%', label: 'ROI Delivered' },
      { value: '186', label: 'Units Delivered' },
      { value: '28', label: 'Months Timeline' },
      { value: '₹42 Cr', label: 'Total Value' },
    ],
  },
  {
    name: 'Residences at Koregaon',
    location: 'Koregaon Park, Pune',
    status: 'COMPLETED',
    image: koregaonImage,
    metrics: [
      { value: '31%', label: 'ROI Delivered' },
      { value: '94', label: 'Units Delivered' },
      { value: '22', label: 'Months Timeline' },
      { value: '₹68 Cr', label: 'Total Value' },
    ],
  },
  {
    name: 'Commercial Hub 37',
    location: 'Hinjewadi, Pune',
    status: 'COMPLETED',
    image: commercialImage,
    metrics: [
      { value: '19%', label: 'ROI Delivered' },
      { value: '240', label: 'Units Delivered' },
      { value: '36', label: 'Months Timeline' },
      { value: '₹95 Cr', label: 'Total Value' },
    ],
  },
  {
    name: 'Riverfront District',
    location: 'Kharadi, Pune',
    status: 'COMPLETED',
    image: riverfrontImage,
    metrics: [
      { value: '27%', label: 'ROI Delivered' },
      { value: '132', label: 'Units Delivered' },
      { value: '30', label: 'Months Timeline' },
      { value: '₹54 Cr', label: 'Total Value' },
    ],
  },
];

function StoriesSection() {
  return (
    <section id="stories" className="outcomes-section">
      <p className="outcomes-tagline">Track Record</p>
      <h2 className="outcomes-heading">Proven Outcomes</h2>
      <p className="outcomes-description">
        Real projects. Measurable results. Consistent delivery across markets
      </p>

      <div className="outcomes-grid">
        {outcomeStories.map((story) => (
          <article key={story.name} className="outcome-card">
            <div className="outcome-image-wrap">
              <img className="outcome-image" src={story.image} alt={`${story.name} architectural visual`} />
            </div>

            <div className="outcome-content">
              <span className="outcome-status">{story.status}</span>
              <h3 className="outcome-title">{story.name}</h3>
              <p className="outcome-location">Location: {story.location}</p>

              <div className="outcome-metrics">
                {story.metrics.map((metric) => (
                  <div className="outcome-metric" key={metric.label}>
                    <div className="outcome-metric-value">{metric.value}</div>
                    <div className="outcome-metric-label">{metric.label}</div>
                  </div>
                ))}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

export default StoriesSection;
